import { faker } from "@faker-js/faker";
import { Card } from "../../Common/Card";
import Centered from "../../Common/Centered";
import Layout from "../../Common/Layout";
import Spacer from "../../Common/Spacer";

const SelectDemoCard = () => {
	return (
		<Card variant="secondary" title="Card test">
			<Spacer mb=".5em">Select Test</Spacer>
			<Centered horizontal>
				<Layout horizontal responsive gap={".5em"}>
					<select name="demo-select">
						{faker.random
							.words(100)
							.split(" ")
							.map((word, idx) => (
								<option key={word + "_" + idx} value={word}>
									{word}
								</option>
							))}
					</select>
					<select name="demo-select">
						{faker.random
							.words(100)
							.split(" ")
							.map((word, idx) => (
								<option key={word + "_" + idx} value={word}>
									{word}
								</option>
							))}
					</select>
					<select name="demo-select">
						{faker.random
							.words(100)
							.split(" ")
							.map((word, idx) => (
								<option key={word + "_" + idx} value={word}>
									{word}
								</option>
							))}
					</select>
					<select name="demo-select">
						{faker.random
							.words(100)
							.split(" ")
							.map((word, idx) => (
								<option key={word + "_" + idx} value={word}>
									{word}
								</option>
							))}
					</select>
				</Layout>
			</Centered>
		</Card>
	);
};

export default SelectDemoCard;
